import $ from 'jquery';
import AjaxFormManager from './classes/AjaxFormManager';
require('jquery-serializejson');

if (typeof AuthService === 'undefined' || !AuthService) {
  throw new Error('Auth service is required');
}

$(() => {
  let $modal = $('#authModal');
  if ($modal.length === 1) {
    /**
     * @param {string} target Targeted panel ID
     */
    let switchPanel = (target) => {
      let $origin = $modal.find('.auth-panel.open');
      let $target = $modal.find('#' + target);

      if ($origin.length === 1 && $target.length === 1) {
        $origin
          .fadeOut(() => {
            $target.fadeIn().addClass('open');
          })
          .removeClass('open');
      }
    };

    /**
     * Display "Access denied" panel
     */
    let displayAccessDenied = () => {
      switchPanel('authAccessDenied');
      setTimeout(() => {
        $modal.find('.close').hide();
        $modal.modal('show');
      }, 300);
    };

    // Login
    $modal.find('form.auth-form-login').on('submit.login', (e) => {
      e.preventDefault();

      AjaxFormManager.sendRequest(
        AuthService.ajaxurl,
        'login',
        $(e.currentTarget),
        true
      ).then((data) => {
        if (data.success) {
          // reload page
          setTimeout(() => {
            document.location.href = AuthService.redirecturl;
          }, 3000);
        }
      });
    });

    // Forgotten password
    $modal.find('form.auth-form-forgot-pass').on('submit.forgot_pass', (e) => {
      e.preventDefault();

      AjaxFormManager.sendRequest(
        AuthService.ajaxurl,
        'forgot_pass',
        $(e.currentTarget),
        true
      );
    });

    // Register
    $modal.find('form.auth-form-register').on('submit.register', (e) => {
      e.preventDefault();

      AjaxFormManager.sendRequest(
        AuthService.ajaxurl,
        'register',
        $(e.currentTarget),
        true
      );
    });

    // Switch panel
    $modal.on('click.switch_auth_panel', '.auth-toggle', (e) => {
      e.preventDefault();
      switchPanel($(e.currentTarget).data('target'));
    });

    // Access denied
    if (AuthService.forbidden == 1) {
      displayAccessDenied();
    }

    // Reset password modal
    $('#authResetPasswordModal')
      // display modal
      .modal('show')
      // remove after hide
      .on('.hidden.bs.modal', (e) => $(e.currentTarget).remove())
      // display login form
      .on('click.login_form', '.auth-rp-toggle', (e) => {
        e.preventDefault();

        $(e.delegateTarget).modal('hide');
        $modal.modal('show');
      })
      // ajax request on submit
      .find('form.auth-form')
      .on('submit.reset_pass', (e) => {
        e.preventDefault();

        AjaxFormManager.sendRequest(
          AuthService.ajaxurl,
          'reset_pass',
          $(e.currentTarget),
          true
        );
      });

    // Display the "Access denied" panel by clicking on the private link
    $(document).on('click.hcp_resource', '.auth-hcp-protect', (e) => {
      e.preventDefault();
      displayAccessDenied();
    });
  }
});



// WEBPACK FOOTER //
// ./scripts/auth.js